import { Component, inject } from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';
import { AsyncPipe } from '@angular/common';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loader',
  imports: [AsyncPipe, LottieComponent],
  template: `
    @if(loading$ | async){
    <div
      class="top-0 left-0 overflow-y-hidden flex justify-center py-4 items-center bg-black/70 z-10000000 w-full h-full fixed"
    >
      <div class="flex flex-col items-center justify-center py-4 w-[30%]">
        <!-- <div>
          <ng-lottie [options]="optionOne"></ng-lottie>
        </div> -->
        <div class="h-60">
          <ng-lottie [options]="optionTwo"></ng-lottie>
        </div>
      </div>
    </div>

    }
  `,
})
export class LoaderComponent {
  private loadingService = inject(LoadingService);
  loading$ = this.loadingService.loading$;
  private sub!: Subscription;

  optionOne: AnimationOptions = {
    path: '/lottie-animations/map.json',
    loop: true,
    autoplay: true,
  };
  optionTwo: AnimationOptions = {
    path: '/lottie-animations/internal-loader.json',
    loop: true,
    autoplay: true,
  };

  ngOnInit() {
    this.sub = this.loading$.subscribe((isLoading) => {
      if (isLoading) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    document.body.style.overflow = '';
  }
}
